import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon, TrendingUpIcon, GraduationCapIcon, GlobeIcon, RocketIcon, NetworkIcon, CircuitBoardIcon, BuildingIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Partners() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    t
  } = useLanguage();
  const partners = [{
    name: 'European Innovation Council',
    typeKey: 'partners.t1',
    icon: SparklesIcon
  }, {
    name: 'Hungarian Investment Agency',
    typeKey: 'partners.t2',
    icon: TrendingUpIcon
  }, {
    name: 'Budapest University of Technology',
    typeKey: 'partners.t3',
    icon: GraduationCapIcon
  }, {
    name: 'EU Digital Alliance',
    typeKey: 'partners.t4',
    icon: GlobeIcon
  }, {
    name: 'Startup Hungary',
    typeKey: 'partners.t5',
    icon: RocketIcon
  }, {
    name: 'V4 Tech Network',
    typeKey: 'partners.t6',
    icon: NetworkIcon
  }, {
    name: 'Digital Europe Programme',
    typeKey: 'partners.t7',
    icon: CircuitBoardIcon
  }, {
    name: 'Central European Tech Hub',
    typeKey: 'partners.t8',
    icon: BuildingIcon
  }];
  return <section id="partners" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderTop: '1px solid var(--border)'
  }} data-id="element-319">
      <div className="relative z-10 mx-auto max-w-7xl" data-id="element-320">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12 sm:mb-16 text-center" data-id="element-321">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-322">
            {t('partners.title')}
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-323">
            {t('partners.desc')}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-id="element-324">
          {partners.map((partner, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} data-id="element-325">
              <div className="h-full rounded-2xl border p-6 flex flex-col items-center justify-center text-center transition-colors hover:bg-[var(--bg-tertiary)]" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-primary)'
          }} data-id="element-326">
                <div className="w-12 h-12 mb-4 rounded-full flex items-center justify-center" style={{
              backgroundColor: 'rgba(59, 130, 246, 0.1)'
            }} data-id="element-327">
                  <partner.icon className="w-6 h-6" style={{
                color: 'var(--accent)'
              }} data-id="element-328" />
                </div>
                <h3 className="text-sm font-bold mb-2" style={{
              color: 'var(--text-primary)'
            }} data-id="element-329">
                  {partner.name}
                </h3>
                <span className="text-xs" style={{
              color: 'var(--text-muted)'
            }} data-id="element-330">
                  {t(partner.typeKey)}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}